import { TipoMarketplace } from "../enum/TipoMarketplace";

export enum TipoElementoVinculo {
    produto = "produto",
    sabor = "sabor",
    borda = "borda",
    massa = "massa"
}

export interface IVinculoMarketplaceProduto {
    uuid?: string;
    tipoMarketplace: TipoMarketplace | string;
    marketplaceUuid?: string;
    tipoElemento?: TipoElementoVinculo;
    codigoItemExterno: string;
    // Para subelementos de pizza (sabor/borda/massa): id do tamanho iFood ao qual pertencem.
    codigoTamanhoExterno?: string;
    nomeItemExterno?: string;
    produtoUuid: string;
    // Para subelementos: uuid do sabor/borda/massa dentro do produto.
    elementoUuid?: string;
    categoriaUuid?: string;
}
